<template>
    <div class="fixed-media" style-type="hotspot" v-on:click.stop="showMessage">
        <div v-for="map in fixedMedia.maps" class="hotspot-container">
            <hotspot v-for="(spot, index) in map.hotspots" :current="current"
                     :spot="spot" :key="spot.title" :coords="spot.coords" :ref="index"
                     :image-width="1200" :image-height="1200" :index="index">
            </hotspot>
        </div>
    </div>
</template>

<script>
    import Hotspot from "./Hotspot";
    export default {
        name: "HotspotContainer",
        components: {Hotspot},
        props: {
            fixedMedia: Object
        },

        data: function() {
            return {
                current: null,
                interval: 5000,
                delay: 1000,
                iTimer: null,
                tTimer: null,
                resizeTimer: null,
                visibleHotspots: [],
                allHotspots: []
            }
        },

        mounted() {
            let hotspotContainer = $('.hotspot-container', this.$el);
            this.hotspotSelector = Math.floor(hotspotContainer.length * Math.random());
            let randomHotspot = hotspotContainer[this.hotspotSelector];
            let component = this;

            $(randomHotspot).css( 'display', 'block');
            $(randomHotspot).css( 'background-image', 'url(' + this.fixedMedia.maps[this.hotspotSelector].image + ')' );

            $.each(this.$refs, function() {
                if (this[component.hotspotSelector] !== undefined) {
                    component.allHotspots.push(this[component.hotspotSelector]);
                }
            });

            this.$nextTick(function () {
                $.each(this.allHotspots, function() {
                    if (this.isVisible) {
                        component.visibleHotspots.push(this);
                    }
                });

                this.checkResize();
            });

            $(window).resize(function() {
                let newHotspots = [];
                this.current = null;

                clearTimeout(this.resizeTimer);

                this.resizeTimer = setTimeout(function() {
                    $.each(component.allHotspots, function() {
                        this.position();
                        if(this.isVisible) {
                            newHotspots.push(this);
                        }
                    });

                    component.visibleHotspots = newHotspots;
                    component.checkResize();
                }, 200)
            });
        },

        methods: {
            showRandom: function() {
                let rand = this.visibleHotspots[Math.floor(Math.random() * this.visibleHotspots.length)].$props.index;
                let count = 10;
                let view = this;

                this.current = null;

                setTimeout(function() {

                    if (view.visibleHotspots.length === 1) {
                        rand = 0;
                    } else {

                        while(count > 0 && (rand === view.current || view.current == null)) {
                            rand = view.visibleHotspots[Math.floor(Math.random() * view.visibleHotspots.length)].$props.index;
                            count--;
                        }
                    }
                    view.current = rand;
                }, view.delay);
            },

            checkResize: function () {
                let view = this;
                clearInterval(this.iTimer);

                if (this.visibleHotspots.length > 0) {
                    this.tTimer = setTimeout( function() {view.showRandom(); }, 300);
                    this.iTimer = setInterval( function() {view.showRandom(); }, this.interval);
                }
            },

            showMessage: function () {
                store.setAnnouncementMessageAction("Maps on this site are not interactive, but if you would like to explore our entire dataset in your browser, check out <a href='#'>ReportAll Online</a>. Day passes start at just $2.99/day.");
            }
        }
    }
</script>